export default __webpack_public_path__ + "static/nl-77f06245c1545d22aa4cbe808a083915.svg";